import * as React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import type {ContentfulBlogPostData} from '../ContentfulBlogPost'
import {
  faFacebookSquare,
  faTwitterSquare,
  faLinkedin,
  IconDefinition,
} from '@fortawesome/free-brands-svg-icons'
import cx from 'classnames'

export interface ContentfulBlogPostSocialShareProps {
  href: string
  data: ContentfulBlogPostData
}

export const ContentfulBlogPostSocialShare: React.FC<ContentfulBlogPostSocialShareProps> = props => (
  <div className="columns is-mobile is-centered mt-6">
    <div className="column is-narrow buttons">
      <Facebook {...props} />
      <Twitter {...props} />
      <LinkedIn {...props} />
    </div>
  </div>
)

interface ShareLinkProps {
  icon: IconDefinition
  baseUrl: string
  params: {[name: string]: string}
  backgroundColor?: string
}

const ShareLink: React.FC<ShareLinkProps> = ({icon, baseUrl, params, backgroundColor}) => {
  const url = new URL(baseUrl)
  Object.entries(params)
    .filter(([_name, value]) => !!value)
    .forEach(([name, value]) => {
      url.searchParams.append(name, encodeURIComponent(value))
    })
  return (
    <a className="button is-text" rel="noopener noreferrer" target="_blank" href={url.toString()}>
      <FontAwesomeIcon size="lg" icon={icon} className={cx('icon is-medium', backgroundColor)} />
    </a>
  )
}

const LinkedIn: React.FC<ContentfulBlogPostSocialShareProps> = ({href}) => (
  <ShareLink
    icon={faLinkedin}
    baseUrl="https://www.linkedin.com/sharing/sharing-offsite/"
    params={{
      url: href,
    }}
    backgroundColor="linkedInIcon"
  />
)

const Twitter: React.FC<ContentfulBlogPostSocialShareProps> = ({href}) => (
  <ShareLink
    icon={faTwitterSquare}
    baseUrl="https://twitter.com/home"
    params={{
      status: href,
    }}
    backgroundColor="twitterIcon"
  />
)

const Facebook: React.FC<ContentfulBlogPostSocialShareProps> = ({href}) => (
  <ShareLink
    backgroundColor="facebookIcon"
    icon={faFacebookSquare}
    baseUrl="https://www.facebook.com/sharer/sharer.php"
    params={{
      href: href,
    }}
  />
)
